import React, { useState, useEffect } from 'react';

const CategoryFilter = ({ categories, activeCategory, onCategoryChange }) => {
  const [isMobile, setIsMobile] = useState(false);
  
  useEffect(() => {
    // Function to check if screen width is mobile
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    // Initial check
    checkMobile();
    
    // Add event listener
    window.addEventListener('resize', checkMobile);
    
    // Cleanup
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  
  // Mobile-specific styles
  const mobileButtonStyle = {
    fontSize: '0.8rem',
    paddingLeft: '0.75rem',
    paddingRight: '0.75rem'
  };
  
  const mobileContainerStyle = {
    display: 'flex',
    flexWrap: 'nowrap',
    overflowX: 'auto',
    scrollbarWidth: 'none', // Firefox
    msOverflowStyle: 'none', // IE/Edge
    WebkitOverflowScrolling: 'touch' // Smooth scrolling on iOS
  };
  
  // Hide scrollbar for Chrome, Safari and Opera
  const hideScrollbarStyle = {
    '::-webkit-scrollbar': {
      display: 'none'
    }
  };

  return (
    <div className="mb-8">
      <div className="w-full">
        <div 
          className={`flex gap-2 ${!isMobile ? 'flex-wrap' : ''}`}
          style={isMobile ? {...mobileContainerStyle} : {}}
        >
          <style jsx>{`
            /* Hide scrollbar for Chrome, Safari and Opera */
            div::-webkit-scrollbar {
              display: none;
            }
            
            /* Hide scrollbar for IE, Edge and Firefox */
            div {
              -ms-overflow-style: none;  /* IE and Edge */
              scrollbar-width: none;  /* Firefox */
            }
          `}</style>
          
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => onCategoryChange(category)}
              style={isMobile ? {...mobileButtonStyle, flexShrink: 0} : {}}
              className={`px-3 py-1.5 rounded-full text-sm font-medium transition-colors whitespace-nowrap
                ${activeCategory === category 
                  ? 'bg-red-600 text-white shadow-md' 
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`}
            >
              {category}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CategoryFilter;
